import { render } from "./BulkPointAllocationTargetSearch.vue?vue&type=template&id=012633c8&scoped=true&ts=true"
import script from "./BulkPointAllocationTargetSearch.vue?vue&type=script&lang=ts"
export * from "./BulkPointAllocationTargetSearch.vue?vue&type=script&lang=ts"

import "./BulkPointAllocationTargetSearch.vue?vue&type=style&index=0&id=012633c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012633c8"]])

export default __exports__